// Maps a ServiceReport neutral chart spec { chart_type, title, labels, series } to a Chart.js config.
// Shared by the web Stimulus controller and (later) the headless-Chrome PNG renderer, so the two
// never diverge. `colors` is the workspace brand palette (primary, secondary, then fallbacks).

export function buildChartConfig(spec, colors) {
  const palette = colors && colors.length ? colors : ["#000000", "#666666"];
  const colorAt = (i) => palette[i % palette.length];
  const labels = spec.labels || [];
  const series = spec.series || [];

  if (spec.chart_type === "pie") {
    const first = series[0] || { data: [] };
    return {
      type: "pie",
      data: {
        labels,
        datasets: [{ data: first.data || [], backgroundColor: labels.map((_, i) => colorAt(i)) }],
      },
      options: baseOptions(spec, { pie: true }),
    };
  }

  // bar (vertical) or line
  return {
    type: spec.chart_type,
    data: {
      labels,
      datasets: series.map((s, i) => ({
        label: s.name,
        data: s.data || [],
        backgroundColor: colorAt(i),
        borderColor: colorAt(i),
        fill: false,
      })),
    },
    options: baseOptions(spec, { pie: false, multiSeries: series.length > 1 }),
  };
}

function baseOptions(spec, { pie, multiSeries }) {
  return {
    animation: false, // matches the PDF/print handling used elsewhere; also needed for PNG capture
    responsive: true,
    maintainAspectRatio: false,
    devicePixelRatio: 2.0,
    plugins: {
      legend: { display: Boolean(pie || multiSeries), position: "bottom" },
      title: { display: false }, // the title is rendered as an <h3> in the ERB
    },
    scales: pie ? {} : { y: { beginAtZero: true } },
  };
}
